export default "__VITE_ASSET__CoXSDSfu__"